import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Course: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.488 4.20823L2.004 6.49516L1.992 10.5616L1.98 14.628L0.99 15.7074L0 16.7868V17.7502V18.7136L1.494 20.347C2.31569 21.2454 2.9934 21.9805 3 21.9805C3.0066 21.9805 3.68429 21.2454 4.506 20.347L6 18.7136V17.7503V16.7871L5.004 15.7006L4.008 14.6142V11.9763V9.33844L4.206 9.42187C4.31489 9.46773 4.7604 9.6538 5.196 9.83534L5.988 10.1654L5.9941 12.8222L6.00022 15.4791L6.0541 15.5131C6.09458 15.5387 11.5151 18.3612 12.8072 19.0295L13.0024 19.1304L16.4912 17.318L19.98 15.5055L19.992 12.8372L20.004 10.1688L22.0014 9.33842L23.9988 8.50802L23.9988 7.50002L23.9988 6.49202L18.524 4.21202C15.5129 2.95802 13.0319 1.92959 13.0106 1.92664C12.9894 1.92369 10.5042 2.95041 7.488 4.20823ZM8.976 5.76242C6.765 6.68411 4.92492 7.45267 4.88693 7.47033C4.82035 7.50124 4.96673 7.56451 8.89493 9.20263C11.1373 10.1378 12.9828 10.903 12.996 10.9032C13.02 10.9037 21.0097 7.57987 21.1165 7.52507C21.1715 7.4968 21.17 7.49481 21.0565 7.44633C20.9445 7.3985 13.2519 4.19157 13.08 4.12106L12.996 4.08659L8.976 5.76242ZM8.02183 12.646L8.028 14.2812L10.5 15.5681C11.8596 16.276 12.9838 16.8553 12.9982 16.8556C13.0126 16.8558 14.1439 16.2747 15.5122 15.5642L18 14.2724V12.6442C18 11.7487 17.9936 11.016 17.9857 11.016C17.9779 11.016 16.879 11.4714 15.5437 12.0279C14.2085 12.5845 13.089 13.0502 13.056 13.0628C13.0046 13.0824 12.6415 12.9379 10.536 12.06C9.183 11.4959 8.06242 11.029 8.04583 11.0225C8.02176 11.0131 8.01691 11.3407 8.02183 12.646ZM2.496 17.0321L2.004 17.5726L1.99771 17.7443L1.9914 17.916L2.48717 18.456C2.75983 18.753 2.99059 18.996 3 18.996C3.00941 18.996 3.24017 18.753 3.51283 18.456L4.0086 17.916L4.00229 17.7443L3.996 17.5726L3.504 17.0321C3.2334 16.7348 3.0066 16.4916 3 16.4916C2.9934 16.4916 2.7666 16.7348 2.496 17.0321Z'
        fill={fill}
      />
    </svg>
  )
}

export default Course
